import Store from "../configureStore";

export const getTeamsArrayAfterRemoveTeam = removedId => {
  const project = Store.getState().Init.data.project;
  const teams = project.teams;
  return teams.filter(team => parseInt(team.id) !== parseInt(removedId));
};

export const getTeamsArrayAfterAddTeam = addedTeam => {
  const project = Store.getState().Init.data.project;
  const teams = project.teams;
  return [...teams, addedTeam];
};

export const getTeamsArrayAfterEditTeam = editedTeam => {
  const project = Store.getState().Init.data.project;
  const teams = project.teams;
  let newTeams = [];
  teams.forEach(team => {
    if (parseInt(team.id) === parseInt(editedTeam.id)) {
      newTeams.push(editedTeam);
    } else {
      newTeams.push(team);
    }
  });
  return newTeams;
};
